import { combineReducers } from '@reduxjs/toolkit';
import api from '../api/api';

// reducers
import messagesDictionariesReducer from './dictionaries/slices';
import messagesGeneralReducer from '../hoc/store/slices/general';
import messageReducer from '../hoc/store/slices/message';

export const reducers = {
  messagingApi: api.reducer,
  messagesDictionaries: messagesDictionariesReducer,
  messages: combineReducers({
    general: messagesGeneralReducer,
    message: messageReducer,
  }),
};

export const messagesApi = api;
